import { createApp } from 'vue';
import App from './app.vue';
import router from './router/router';
import store, { key } from './store';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import 'normalize.css';
import '@/business/chat/init-message-config.ts';
import filters from './framework/filters';
import service from './framework/service';
import toastInstall from '@/component/kk-toast/install';
import confirmInstall from '@/component/kk-confirm/install';
import { handlerNetFail } from './framework/init';
import { aegis } from '_c/util/aegis';

service();

const app = createApp(App);
app.config.errorHandler = (err, vm, info) => {
  if (typeof err === 'object') {
    const { message = '', stack = '' } = err as {message: string, stack: string};
    aegis.error(`Error: ${message}\nStack: ${stack}\nInfo: ${info}`);
  }
};
app.use(store, key);
app.use(router);
app.use(filters);
app.use(toastInstall);
app.use(confirmInstall);
app.use(VueDOMPurifyHTML, {
  hooks: {
    afterSanitizeAttributes: (node: HTMLElement) => {
      if ('target' in node) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener');
      }
    },
  },
});

app.mount('#app');

handlerNetFail(router, store);
